import React from 'react';
export const CTA = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="w-full pt-6 pb-12 px-6 md:px-10 bg-white" data-id="element-77">
      <div className="max-w-[1400px] mx-auto flex justify-center" data-id="element-78">
        <div className="relative bg-gradient-to-br from-[#3d8f5a] to-[#2c5f2d] rounded-3xl p-8 md:p-12 overflow-hidden max-w-5xl w-full" data-id="element-79">
          {/* Decorative circles */}
          <div className="absolute top-10 right-10 w-32 h-32 rounded-full bg-white/10 backdrop-blur-sm" data-id="element-80"></div>
          <div className="absolute bottom-10 right-16 w-24 h-24 rounded-full bg-white/10 backdrop-blur-sm" data-id="element-81"></div>
          {/* Content */}
          <div className="relative z-10 max-w-3xl" data-id="element-82">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight" data-id="element-83">
              Не нашли свой запрос, не понимаете, что беспокоит, или не уверены,
              что вам поможет — напишите мне
            </h2>
            <p className="text-lg md:text-xl text-white/95 mb-6" data-id="element-84">
              Назначим бесплатную 30-минутную встречу
            </p>
            <button onClick={scrollToContact} className="px-8 py-3 bg-white text-[#2c5f2d] text-base font-semibold uppercase tracking-wider rounded-full hover:bg-gray-50 transition-all hover:scale-105 shadow-lg" data-id="element-85">
              Написать
            </button>
          </div>
        </div>
      </div>
    </section>;
};